/**
 * ProductTabs 组件 - 稳健版
 * 解决：动态加载导致事件失效、多重绑定导致双倍触发
 */
class ProductTabs extends HTMLElement {
    constructor() {
        super();

        // 1. 初始化变量与状态
        this.tab = this.querySelectorAll('.tab-title');
        this.tabContents = this.querySelector('.tabs-contents');
        this.tabContent = this.querySelectorAll('.tab-content');
        this.link = this.querySelectorAll('.toggleLink');
        this.readMore = this.querySelectorAll('[data-show-more-toogle]');
        this.tabClose = this.querySelectorAll('.pdViewTab-close');
        
        this.isVerticalPopup = this.dataset.vertical === 'sidebar';
        this.isVerticalSidebarMobile = this.dataset.verticalMobile === 'sidebar-mobile';

        // 2. 核心：委托监听 (Event Delegation) 
        // 这种模式专治“不生效”的界面，因为它监听的是容器
        this.addEventListener('click', (event) => {
            const toggleLink = event.target.closest('.toggleLink');
            if (!toggleLink) return;

            // 防重判断：如果元素已被直接绑定处理过，则代理模式跳过
            if (!toggleLink.dataset.handledByLoop) {
                this.tabToggle(event);
            }
        });

        // 3. 核心：直接绑定 (Direct Binding)
        // 并在元素上打标签，防止代理模式再次触发
        this.link.forEach((item) => {
            item.dataset.handledByLoop = 'true'; // 标记已处理
            item.addEventListener('click', (e) => {
                this.tabToggle(e);
            });
        });

        // 4. 其他常规绑定 (使用 let 确保作用域安全)
        this.tab.forEach(el => el.addEventListener('click', this.tabActive.bind(this)));
        this.readMore.forEach(el => el.addEventListener('click', this.readMoreReadLess.bind(this)));
        this.tabClose.forEach(el => el.addEventListener('click', this.productTabClose.bind(this)));

        if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
            const overlay = document.querySelector('.background-overlay');
            if(overlay) overlay.addEventListener('click', this.onBackgroundClick.bind(this));
        }
        
    }

    // 展开/收起切换逻辑
    tabToggle(event) {
        event.preventDefault();
        event.stopPropagation();

        const $this = event.target.closest('.toggleLink');
        if (!$this) return;

        // 【状态锁】防止连续点击或双重触发导致的闪烁
        if ($this.classList.contains('is-processing')) return;
        $this.classList.add('is-processing');

        // 获取内容块：基于 toggle-title 的下一个兄弟节点
        const $titleContainer = $this.closest('.toggle-title');
        const $thisContent = $titleContainer ? $titleContainer.nextElementSibling : null;

        if (!$thisContent) {
            console.error('未找到关联的内容块 (.toggle-content)');
            $this.classList.remove('is-processing');
            return;
        }

        // 判定 jQuery 是否存在，否则使用原生方法
        const hasJQuery = typeof window.jQuery !== 'undefined';

        if ($this.classList.contains('is-open')) {
            $this.classList.remove('is-open');
            if (hasJQuery) {
                window.jQuery($thisContent).slideUp('slow', () => {
                    $this.classList.remove('is-processing');
                });
            } else {
                $thisContent.style.display = 'none';
                $this.classList.remove('is-processing');
            }
        } else {
            $this.classList.add('is-open');
            if (hasJQuery) {
                window.jQuery($thisContent).slideDown('slow', () => {
                    $this.classList.remove('is-processing');
                });
            } else {
                $thisContent.style.display = 'block';
                $this.classList.remove('is-processing');
            }
        }
    }

    // 顶部选项卡切换逻辑 (Tab Style)
    tabActive(event) {
        event.preventDefault();
        event.stopPropagation();

        const $this = event.target.closest('.tab-title');
        const id = $this.getAttribute('href').replace('#', '');
        const button_tab = document.querySelector('.an-horizontal-shaking');

        if (!$this.classList.contains('is-open')) {
            this.tab.forEach(el => el.classList.remove('is-open'));
            $this.classList.add('is-open');
            
            if (this.tabContents) this.tabContents.classList.add('is-show');
            button_tab?.classList.add('open-tab-content');

            this.tabContent.forEach(content => {
                if (content.getAttribute('id') == id) {
                    content.classList.add('is-active');
                } else {
                    content.classList.remove('is-active');
                }
            });
        }
    }

    // 阅读更多逻辑
    readMoreReadLess(event) {
        event.preventDefault();
        const $this = event.target;
        const id = $this.getAttribute('href').replace('#', '');
        const textShowMore = $this.getAttribute('data-show-more-text');
        const textShowLess = $this.getAttribute('data-show-less-text');
        const parent = $this.closest('.tab-showMore');
        const desMax = parent.dataset.desMax;

        if ($this.classList.contains('is-less')) {
            $this.classList.replace('is-less', 'is-show');
            parent.classList.replace('is-less', 'is-show');
            $this.innerText = textShowMore;
            document.getElementById(id).style.maxHeight = `${desMax}px`;
        } else {
            $this.classList.replace('is-show', 'is-less');
            parent.classList.replace('is-show', 'is-less');
            $this.innerText = textShowLess;
            document.getElementById(id).style.maxHeight = 'unset';
        }
    }

    productTabClose(event) {
        event.preventDefault();
        this.tabContents?.classList.remove('is-show');
        this.tab.forEach(el => el.classList.remove('is-open'));
        this.tabContent.forEach(el => el.classList.remove('is-active'));
    }

    onBackgroundClick() {
        document.querySelector('.toggleLink.is-open')?.classList.remove('is-open');
        document.querySelector('.toggle-content.is-show')?.classList.remove('is-show');
        document.body.classList.remove('tab-popup-show');
    }
}

// 定义自定义元素
if (!customElements.get('product-tab')) {
    customElements.define('product-tab', ProductTabs);
}